export default "__VITE_ASSET__FMSOcDBz__"